import { StateCreator } from 'zustand';
import { Store } from 'src/stores/store.interface';
import { CreateWorkflowWizardStepsDataStore } from './workflowCreateWizardDataStore.interface';

export const defaultCreateWorkflowWizardStepsDataStore = {
	activeStepIndexForCreateWF: 0,
	isModalVisibleForCreateWF: false,
	isExitModalVisibleForCreateWF: false,
	isSubmitLoadingForCreateWF: false,
	istheSubmitButtonClickedForCreateWF: false,
	isCreateWorkflowError: false,
	isReadOnly: false,
};

const createWorkflowWizardStepsDataStore: StateCreator<
	Store,
	[],
	[],
	CreateWorkflowWizardStepsDataStore
> = (set) => ({
	...defaultCreateWorkflowWizardStepsDataStore,
	setActiveStepIndexForCreateWF: (activeStepIndexForCreateWF) =>
		set({ activeStepIndexForCreateWF }),
	setIsModalVisibleForCreateWF: (isModalLoading) =>
		set({ isModalVisibleForCreateWF: isModalLoading }),
	setIsExitModalVisibleForCreateWF: (isModalLoading) =>
		set({ isExitModalVisibleForCreateWF: isModalLoading }),	
	setIsSubmitLoadingForCreateWF: (isSubmitLoading) =>
		set({ isSubmitLoadingForCreateWF: isSubmitLoading }),
	setIstheSubmitButtonClickedForCreateWF: (isSubmitClicked) =>
		set({ istheSubmitButtonClickedForCreateWF: isSubmitClicked }),
	setIsCreateWorkflowError: (isCreateError) =>
		set({ isCreateWorkflowError: isCreateError }),
	setIsReadOnly: (isReadOnly) =>
		set({ isReadOnly }),
});

export default createWorkflowWizardStepsDataStore;
